import React, { useLayoutEffect, useState } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { OwnerShipService } from "../../../apis/apiServices/OwnerShip";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";

export default function OwnerShipTypeComponent(props) {
  // CHANGED: accept props.featurePermission and derive permission booleans (safe defaults)
  const featurePermission = props?.featurePermission || {};
  const canView = !!featurePermission?.canView;
  const canAdd = !!featurePermission?.canAdd;
  const canEdit = !!featurePermission?.canEdit;
  const canDelete = !!featurePermission?.canDelete;

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Ownership Type";
    getOwnershipList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const user = useSelector((state) => state.user?.data || {});
  const navigate = useNavigate();

  const [isCityModalOpen, setIsCityModalOpen] = useState(false); // used for add/edit
  const [isViewModalOpen, setIsViewModalOpen] = useState(false); // used for view
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [OwnershipList, setOwnershipList] = useState([]);

  const [Ownership, SetOwnership] = useState({
    id: 0,
    name: "",
    code: "",
    isActive: true,
  });

  // Fetch list
  const getOwnershipList = async () => {
    try {
      const response = await OwnerShipService.getOwnerShipList();
      setOwnershipList(response?.data ?? []);
    } catch (error) {
      console.error("Error getOwnershipList:", error);
      setOwnershipList([]);
    }
  };

  // single form submit for add/edit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure the user has permission to add/edit
    const isNew = !Ownership?.id;
    if (isNew && !canAdd) {
      Swal.fire("Permission denied", "You don't have permission to add.", "warning");
      return;
    }
    if (!isNew && !canEdit) {
      Swal.fire("Permission denied", "You don't have permission to edit.", "warning");
      return;
    }

    setIsSubmitted(true);

    const newErrors = {};
    if (!Ownership.name) newErrors.name = "Please enter ownership type";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }

    try {
      const body = {
        id: Ownership.id,
        name: Ownership?.name || "",
        code: Ownership?.code || "",
        isActive: Ownership?.isActive || false,
        ModifiedBy: user?.userId ?? 0,
        UserId: user?.userId ?? 0,
      };

      const response = await OwnerShipService.addOwnerShip(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message || "Unable to save"}`, "error");
        setIsSubmitted(false);
        setErrors(response?.errors || {});
        return;
      }

      await getOwnershipList();
      setIsSubmitted(false);
      await Swal.fire("Success!", `${response?.message || "Saved successfully"}`, "success");

      // Use navigate correctly; replace true if you want to replace history
      navigate("/OwnerShiptype", { replace: true });
      closeModal();
    } catch (error) {
      console.error("Submit error:", error);
      setIsSubmitted(false);
    }
  };

  const openModal = () => {
    // open Add modal (ensure Ownership is reset)
    if (!canAdd) {
      Swal.fire("Permission denied", "You don't have permission to add.", "warning");
      return;
    }
    SetOwnership({
      id: 0,
      name: "",
      code: "",
      isActive: true,
    });
    setErrors({});
    setIsCityModalOpen(true);
  };

  const openEditModal = (rowData) => {
    if (!canEdit) {
      Swal.fire("Permission denied", "You don't have permission to edit.", "warning");
      return;
    }
    SetOwnership({
      id: rowData.id,
      name: rowData.name,
      code: rowData.code,
      isActive: !!rowData.isActive,
    });
    setErrors({});
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetOwnership({
      id: 0,
      name: "",
      code: "",
      isActive: true,
    });
  };

  const openViewModal = (rowData) => {
    SetOwnership({
      id: rowData.id,
      name: rowData.name,
      code: rowData.code,
      isActive: !!rowData.isActive,
    });
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false);
  };

  const handleInputChange = (e, field) => {
    
    SetOwnership((prev) => ({
      ...prev,
      [field]: e?.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;
    return <div>{isActive ? "Active" : "Inactive"}</div>;
  };

 
  const handleRowClick = (e) => {
    SetOwnership({
      id: e.data.id,
      name: e.data.name,
      code: e.data.code,
      isActive: e.data.isActive,
    });
  };

  // delete handler - confirm + call API
  const handleDelete = async (rowData) => {
    if (!canDelete) {
      Swal.fire("Permission denied", "You don't have permission to delete.", "warning");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Delete ownership type "${rowData.name}"? You won't be able to revert this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (result.isConfirmed) {
      try {
        // Call your delete API here. Replace with real method if available:
        const response = await OwnerShipService.deleteOwnerShip?.(rowData.id);
        // If API returns structure adapt this check
        if (response && response?.isSuccess === false) {
          Swal.fire("Error", response?.message || "Unable to delete", "error");
          return;
        }
        await getOwnershipList();
        Swal.fire("Deleted!", "Record has been deleted.", "success");
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire("Error", "Failed to delete. See console for details.", "error");
      }
    }
  };

  // submit permission (used to enable/disable submit button)
  const canSubmit = Ownership.id === 0 ? canAdd : canEdit;

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={OwnershipList}
              showRowLines={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnReordering={true}
              width={"100%"}
              onToolbarPreparing={(e) => {
                // CHANGED: only add Add button if canAdd (same pattern as CategoryComponent)
                const items = [];

                if (canAdd) {
                  items.push({
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  });
                }

                items.push({
                  location: "before",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    text: "Refresh",
                    hint: "Refresh",
                    type: "default",
                    stylingMode: "outlined",
                    onClick: () => getOwnershipList(),
                  },
                });

                e.toolbarOptions.items.unshift(...items);
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width="120px"
                caption={""}
                alignment={"center"}
                cellRender={(cellData) => {
                  const row = cellData.data;
                  return (
                    <span>
                     
                      <Icon
                        className="iconify-size mr-2"
                        title="View"
                        tooltip="View"
                        icon="solar:document-text-outline"
                        style={{ cursor: "pointer", marginRight: 8 }}
                        onClick={() => openViewModal(row)}
                      />

                      {/* Edit icon - show only if canEdit */}
                      {canEdit && (
                        <Icon
                          className="iconify-size mr-2"
                          title="Edit"
                          tooltip="Edit"
                          icon="solar:pen-line-duotone"
                          style={{ cursor: "pointer", marginRight: 8 }}
                          onClick={() => openEditModal(row)}
                        />
                      )}

                      {/* Delete icon - show only if canDelete */}
                      {canDelete && (
                        <Icon
                          className="iconify-size"
                          title="Delete"
                          tooltip="Delete"
                          icon="fluent:delete-32-regular"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDelete(row)}
                        />
                      )}
                    </span>
                  );
                }}
              />

              <Column
                width="180px"
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="100px"
                dataField="code"
                caption="Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="200px"
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={false} fileName="Ownerships" />
            </DataGrid>
          </div>
        </div>
      </div>

      
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        className="react-modal custom-modal-small"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={!isSubmitted}
        contentLabel="Ownership Type Modal"
      >
        <form onSubmit={handleSubmit} style={isSubmitted ? { pointerEvents: "none", opacity: 0.6 } : {}}>
          <div className="modal-header">
            <div className="modal-title">{Ownership.id ? "Edit" : "Add"} Ownership Type</div>
          </div>

          <div className="modal-body">
            <div className="form-group">
              <label>
                Name <span className="text-danger">*</span>
              </label>
              <TextBox
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                placeholder="Enter ownership type"
                showClearButton={true}
                valueChangeEvent="keyup"
                value={Ownership.name}
                onValueChanged={(e) => handleInputChange(e, "name")}
                disabled={!canEdit && Ownership.id !== 0} // disable on edit if no edit permission
              />
              {errors.name && <div className="error invalid-feedback">{errors.name}</div>}
            </div>

            <div className="form-group">
              <label>Code</label>
              <TextBox
                className={`form-control ${errors.code ? "is-invalid" : ""}`}
                placeholder="Enter code"
                showClearButton={true}
                valueChangeEvent="keyup"
                value={Ownership.code}
                onValueChanged={(e) => handleInputChange(e, "code")}
              />
              {errors.code && <div className="error invalid-feedback">{errors.code}</div>}
            </div>

            <div className="form-group">
              <CheckBox
                text="Is Active"
                value={Ownership.isActive}
                onValueChanged={(e) => handleInputChange(e, "isActive")}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
              disabled={isSubmitted}
            >
              <i className="fas fa-times"></i> Cancel
            </button>

            <button type="submit" className="btn btn-primary btn-sm" disabled={isSubmitted || !canSubmit}>
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>

      
      <Modal ariaHideApp={false} isOpen={isViewModalOpen} className="react-modal resmodel" onRequestClose={closeViewModal}>
        <div className="modal-header">
          <div className="modal-title">View Ownership Type</div>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <p>
                  <span className="labelview">Code: </span>{" "}
                  <span className="formtextstyle">{Ownership.code}</span>
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <p>
                  <span className="labelview">Ownership Type:</span>{" "}
                  <span className="formtextstyle">{Ownership.name}</span>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <p>
                  <span className="labelview">Status:</span>{" "}
                  <span className="formtextstyle">{Ownership.isActive ? "Active" : "Inactive"}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={closeViewModal} title="Close">
            <i className="fas fa-times"></i> Close
          </button>
        </div>
      </Modal>
    </>
  );
}
